<label class="h5"><b>Seleccione el tipo de orden:</b></label>

<div btnRadioGroup [(ngModel)]="selectedOrderTypeId" (ngModelChange)="sendOrderType()">
  <div class="row" *ngFor="let ot of availableOrderTypes">
    <div class="col-md-6">
      <label class="btn col btn-primary" [btnRadio]="ot.id">{{ ot.description }}</label>
    </div>
  </div>
</div>